import axios from '@/api/axios.config'

const ApiService = {
  get: async (path: string, params?: Record<string, string | number | boolean>) => {
    const { data } = await axios.get(path, { params })

    return data
  },
  post: async (path: string, params?: Object, headers: any = {}) => {
    const { data } = await axios.post(path, params, {
      headers,
    })

    return data
  },
  // Para endpoints que respondem com binário (ex.: PDF). Devolve a resposta
  // completa do axios para que o chamador acesse o blob e os headers.
  postBlob: async (path: string, params?: Object, headers: any = {}) => {
    return axios.post(path, params, {
      headers,
      responseType: 'blob',
    })
  },
  put: async (path: string, params?: Object, headers: any = {}) => {
    const { data } = await axios.put(path, params, {
      headers,
    })

    return data
  },
  patch: async (path: string, params?: Object, headers: any = {}) => {
    const { data } = await axios.patch(path, params, {
      headers,
    })

    return data
  },
  delete: async (path: string, params?: string | Object) => {
    const { data } = await axios.delete(path, { params })

    return data
  },
  deleteWithBody: async (path: string, body?: Object) => {
    const { data } = await axios.delete(path, { data: body })

    return data
  },
}

export default ApiService
